import { clear } from '../../core/dom.js';
import { resolveLocation, startRouter } from '../../core/router.js';
import { renderLogin } from './login.js';
import { renderSignup } from './signup.js';
import { renderAcceptInvite } from './invite.js';

function paint(view) {
  const root = document.getElementById('app');
  clear(root);
  document.title = `${view.title || 'Bonnie'} — BonnieOS`;
  if (view.id === 'login') {
    root.append(renderLogin({ search: view.search }));
    return;
  }
  if (view.id === 'signup') {
    root.append(renderSignup({ search: view.search }));
    return;
  }
  if (view.id === 'accept-invite') {
    root.append(renderAcceptInvite({ search: view.search }));
    return;
  }
  // Fallback: stay on an auth route the router already allowed.
  const login = resolveLocation('/app/login', '', {});
  root.append(renderLogin({ search: login.search }));
}

/** Boot the pre-login auth screens without the signed-in shell. */
export function mountAuth() {
  startRouter({
    context() {
      return { token: '' };
    },
    onRoute(view) {
      if (view.denied || view.missing || view.guard === 'auth') {
        window.location.replace('/app/login');
        return;
      }
      paint(view);
    },
  });
}
